import { render, staticRenderFns } from "./AppointmentBook.vue?vue&type=template&id=85198d40&scoped=true&"
import script from "./AppointmentBook.vue?vue&type=script&lang=js&"
export * from "./AppointmentBook.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentBook.vue?vue&type=style&index=0&id=85198d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85198d40",
  null
  
)

export default component.exports